// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file inventory/v1/alert_rules_service.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import { AlertRuleService } from "./alert_rules_service_pb";

/**
 * @generated from rpc inventory.v1.AlertRuleService.ListAlertRules
 */
export const listAlertRules = AlertRuleService.method.listAlertRules;

/**
 * @generated from rpc inventory.v1.AlertRuleService.GetAlertRule
 */
export const getAlertRule = AlertRuleService.method.getAlertRule;

/**
 * @generated from rpc inventory.v1.AlertRuleService.CreateAlertRule
 */
export const createAlertRule = AlertRuleService.method.createAlertRule;

/**
 * @generated from rpc inventory.v1.AlertRuleService.UpdateAlertRule
 */
export const updateAlertRule = AlertRuleService.method.updateAlertRule;

/**
 * @generated from rpc inventory.v1.AlertRuleService.EnableAlertRule
 */
export const enableAlertRule = AlertRuleService.method.enableAlertRule;

/**
 * @generated from rpc inventory.v1.AlertRuleService.DisableAlertRule
 */
export const disableAlertRule = AlertRuleService.method.disableAlertRule;

/**
 * @generated from rpc inventory.v1.AlertRuleService.DeleteAlertRule
 */
export const deleteAlertRule = AlertRuleService.method.deleteAlertRule;

/**
 * Returns each user-visible signal type plus the questions and options the
 * rule editor offers when that signal type is selected. Drives the editor's
 * signal-type picker and per-question dropdowns. Legacy WOW-typed findings
 * are excluded.
 *
 * @generated from rpc inventory.v1.AlertRuleService.ListSignalTypes
 */
export const listSignalTypes = AlertRuleService.method.listSignalTypes;
